import { render, staticRenderFns } from "./AddPost.vue?vue&type=template&id=4240ddcf&scoped=true&"
import script from "./AddPost.vue?vue&type=script&lang=js&"
export * from "./AddPost.vue?vue&type=script&lang=js&"
import style0 from "./AddPost.vue?vue&type=style&index=0&id=4240ddcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240ddcf",
  null
  
)

export default component.exports